// Note : .kombo-tilt-glow (rotation continue + pulsation lumineuse verte, pour UN élément
// "vedette" par page — carte mise en avant, CTA principal) est une animation CSS pure
// (`animation: infinite`), sans déclenchement JS : pas de logique la concernant dans ce
// fichier. Définition et règle de portée documentées dans assets/funino-tokens.css, juste
// avant `.kombo-tilt-glow`.

(function () {
  'use strict';

  function revealAll(nodeList) {
    nodeList.forEach(function (el) {
      el.classList.add('in-view');
    });
  }

  var targets = document.querySelectorAll('.kombo-reveal, .kombo-float-in');

  if (!targets.length) return;

  if (typeof IntersectionObserver === 'undefined') {
    revealAll(targets);
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('in-view');
          observer.unobserve(entry.target);
        }
      });
    },
    { rootMargin: '0px 0px -8% 0px', threshold: 0.1 }
  );

  targets.forEach(function (el, index) {
    el.style.transitionDelay = Math.min(index % 6, 5) * 60 + 'ms';
    observer.observe(el);
  });

  // Filet de sécurité : une carte peut se retrouver dans le viewport après coup (chargement d'une
  // image, du web font Atma, etc. décalant la mise en page) sans que l'observer ne la re-détecte
  // à temps. On revérifie manuellement une fois toutes les ressources chargées.
  function recheckVisibility() {
    document.querySelectorAll('.kombo-reveal:not(.in-view), .kombo-float-in:not(.in-view)').forEach(function (el) {
      var rect = el.getBoundingClientRect();
      var viewportHeight = window.innerHeight || document.documentElement.clientHeight;
      if (rect.top < viewportHeight * 0.92 && rect.bottom > 0) {
        el.classList.add('in-view');
        observer.unobserve(el);
      }
    });
  }

  if (document.readyState === 'complete') {
    recheckVisibility();
  } else {
    window.addEventListener('load', recheckVisibility);
  }

  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(recheckVisibility);
  }
})();

(function () {
  'use strict';

  // Iceberg superposé (page Méthode) : les deux cartes partagent le même centre au repos, donc
  // le système .kombo-reveal générique (fade-up indépendant par élément) ne convient pas — il
  // faut un seul déclenchement qui bascule les deux cartes en simultané. Indépendant du bloc
  // ci-dessus par conception.
  var stages = document.querySelectorAll('[data-iceberg-stage]');

  if (!stages.length) return;

  function reveal(stage) {
    stage.classList.add('is-revealed');
  }

  if (typeof IntersectionObserver === 'undefined') {
    stages.forEach(reveal);
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          reveal(entry.target);
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.35 }
  );

  stages.forEach(function (stage) {
    observer.observe(stage);
  });
})();
